"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Framework class for ReferenceGroup controls
         */
        var ReferenceGroup = /** @class */ (function (_super) {
            __extends(ReferenceGroup, _super);
            function ReferenceGroup() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(ReferenceGroup.prototype, "StatusArea", {
                get: function () {
                    if (this._statusArea === undefined && this._lastChild && this._lastChild.element) {
                        var foundStatusArea = $(this._lastChild.element).find(".field-status");
                        if (foundStatusArea.length === 0) {
                            foundStatusArea = null;
                        }
                        this._statusArea = foundStatusArea;
                    }
                    return this._statusArea;
                },
                enumerable: false,
                configurable: true
            });
            ReferenceGroup.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.isFocused = $dyn.observable(false);
                this.IsHyperlink = $dyn.observable(false);
                if (!$dyn.isObservable(this.Enabled)) {
                    this.Enabled = $dyn.observable(this.Enabled);
                }
                this._allowEdit = $dyn.observable(true);
                this.AllowEdit = $dyn.computed(function () {
                    var e_1, _a;
                    if (!_this._allowEdit()) {
                        return false;
                    }
                    var children = $dyn.value(_this.Children);
                    if (children) {
                        try {
                            for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                                var child = children_1_1.value;
                                if (!$dyn.value(child.AllowEdit)) {
                                    return false;
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                    }
                    return true;
                }, function (value) {
                    _this._allowEdit(value);
                });
                this._isViewMode = $dyn.observable(true);
                this.IsViewMode = $dyn.computed(function () {
                    var e_2, _a;
                    if (!_this._isViewMode()) {
                        return false;
                    }
                    var children = $dyn.value(_this.Children);
                    if (children) {
                        try {
                            for (var children_2 = __values(children), children_2_1 = children_2.next(); !children_2_1.done; children_2_1 = children_2.next()) {
                                var child = children_2_1.value;
                                if (!$dyn.value(child.IsViewMode)) {
                                    return false;
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (children_2_1 && !children_2_1.done && (_a = children_2.return)) _a.call(children_2);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                    return true;
                }, function (value) {
                    _this._isViewMode(value);
                });
                $dyn.observe(this.Children, function (newCollectionValue) {
                    _this._childrenCollection = []; // Children of this lookup have changed. Clear the old children
                    _this._lastChild = undefined;
                    _this._statusArea = undefined;
                    var newCollection = $dyn.value(newCollectionValue);
                    if (!newCollection) {
                        return;
                    }
                    $dyn.setValue(_this, "IsHyperlink", false);
                    newCollection.forEach(function (item, i) {
                        var itemAsEdit = item;
                        _this._childrenCollection.push(itemAsEdit);
                        itemAsEdit.updatingBlock(function () {
                            if (itemAsEdit.StatusIndicator !== undefined) {
                                if (i === (newCollection.length - 1)) {
                                    _this._lastChild = itemAsEdit;
                                    _this._lastChild.StatusIndicator($dyn.value(_this.StatusIndicator));
                                }
                                else {
                                    // If child input control has a status indicator hide it, only want indicator on entire control
                                    itemAsEdit.StatusIndicator($dyn.ui.StatusIndicator.none);
                                }
                            }
                            $dyn.setValue(itemAsEdit, "Required", $dyn.value(_this.Required));
                            itemAsEdit.ReferenceGroup = _this;
                            if (!$dyn.value(_this.IsHyperlink) && $dyn.value(itemAsEdit.IsHyperlink)) {
                                $dyn.setValue(_this, "IsHyperlink", true);
                            }
                            // All reference group children should be SizeToAvailable so that they size equally within the group.
                            // Leverage a self-executing function so the closure gets the right context when the inner function is invoked.
                            if (item.LayoutWidth) {
                                $dyn.observe(item.LayoutWidth, function childLayoutWidthChanged(newValue) {
                                    if (newValue !== $dyn.layout.Size.available) {
                                        $dyn.setValue(item, "LayoutWidth", $dyn.layout.Size.available);
                                    }
                                });
                            }
                        });
                    });
                    _this.UpdateStatusArea();
                });
                if (!this.isInactiveCell()) {
                    $dyn.observe(this.StatusIndicator, function (newValue) {
                        if (_this._lastChild && _this._lastChild.StatusIndicator) {
                            _this._lastChild.StatusIndicator(newValue);
                        }
                    });
                    $dyn.observe(this.IsValid, function (newValue) {
                        if (_this.Root && _this.Root.UpdateInvalidControlList) {
                            _this.Root.UpdateInvalidControlList(_this);
                        }
                        if (newValue) {
                            _this.removeMessages();
                            var children_3 = $dyn.value(_this.Children);
                            if (children_3) {
                                children_3.forEach(function (item) {
                                    var itemAsEdit = item;
                                    var itemAsBaseInput = item;
                                    if (itemAsEdit.IsValid && !$dyn.value(itemAsEdit.IsValid)) {
                                        // Changing from invalid to valid updates the formattedValue to a valid value
                                        itemAsEdit.IsValid(true);
                                    }
                                    else if (itemAsBaseInput.compareToParsedValue && !itemAsBaseInput.compareToParsedValue($dyn.value(itemAsBaseInput.Value))) {
                                        itemAsBaseInput.updatingBlock(function () {
                                            if (itemAsBaseInput.updateParsedValue && itemAsBaseInput.formattedValue) {
                                                itemAsBaseInput.updateParsedValue($dyn.value(itemAsBaseInput.Value));
                                                itemAsBaseInput.formattedValue.valueChanged.raise();
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        _this.UpdateStatusArea();
                    });
                    $dyn.observe(this.Required, function (newValue) {
                        // set required value
                        var children = $dyn.value(_this.Children);
                        if (children) {
                            children.forEach(function (item) {
                                var itemAsEdit = item;
                                if (itemAsEdit) {
                                    itemAsEdit.Required(newValue);
                                }
                            });
                        }
                    });
                    this.flyoutClickSubscriber = function (options) {
                        // Do not execute close lookup logic if the click was in the same reference group
                        var clickTargetControl = $dyn.context(options.clickTarget);
                        if (clickTargetControl && clickTargetControl.ReferenceGroup === _this) {
                            return false;
                        }
                        return $dyn.util.flyout.defaultFlyoutClickSubscriber(options);
                    };
                }
                if (this.CustomPopup) {
                    this.showPopup = this.CustomPopup;
                }
                else {
                    $dyn.ui.popupHost.apply(this);
                }
                var clientState = $dyn.value(this.ClientState);
                if (clientState && typeof (clientState) === "string") {
                    // We will only parse clientState if it's a string
                    if (this.applyClientState) {
                        var clientStateAsObj_1 = JSON.parse(clientState);
                        // Something was set on the server as client-only state.
                        // Do an async call to process this value.
                        $dyn.async(function () {
                            _this.applyClientState(clientStateAsObj_1);
                        });
                    }
                }
            };
            /**
             * The function to be called when the control loses focus
             * @param event The focus out event
             */
            ReferenceGroup.prototype.focusOutCallBack = function (event) {
                if (this.isFocusOutTargetFlyout(event) || this.isResizingInLookup(event)) {
                    // Focus is going into the hosted flyout. No-op.
                    return;
                }
                this.isFocused(false);
                $dyn.log.focus && $dyn.log.focus("Focus: RefrenceGroup->focusOutCallBack input name: %s", this.Name);
                this.resolveChanges();
                this.UpdateStatusArea();
                this.focusOutCleanup();
            };
            /**
             * The function to be called when the control gains focus
             * @param event The focus event
             */
            ReferenceGroup.prototype.focusInCallBack = function () {
                $dyn.log.focus && $dyn.log.focus("Focus: RefrenceGroup->focusInCallBack input name: %s", this.Name);
                this.isFocused(true);
                if ($dyn.value(this.AllowEdit)) {
                    this.StatusIndicator($dyn.ui.StatusIndicator.none);
                }
            };
            ReferenceGroup.prototype.FindFocusTarget = function () {
                var $found;
                if (document.activeElement) {
                    var activeControlContext = $dyn.context(document.activeElement);
                    if (activeControlContext && activeControlContext.ReferenceGroup === this) {
                        $found = $(document.activeElement);
                    }
                }
                if (!$found) {
                    var children_4 = $dyn.value(this.Children);
                    if (children_4 && children_4.length) {
                        $found = $(children_4[0].$inputElement);
                    }
                    else {
                        $found = $();
                    }
                }
                return $found;
            };
            /**
             * Sync the values of the children with their backing value
             */
            ReferenceGroup.prototype.syncValues = function () {
                var children = $dyn.value(this.Children);
                if (children) {
                    children.forEach(function (item) {
                        var itemAsInput = item;
                        if (itemAsInput.syncValues) {
                            itemAsInput.syncValues();
                        }
                    });
                }
            };
            /**
             * Update the value of the specified child control without making the reference group become dirty
             * @param control The child control to update
             * @param newValue The new value to set on the control
             */
            ReferenceGroup.prototype.setChildValue = function (control, newValue) {
                // Set the value of a child control of this ReferenceGroup and notify the referencegroup that a sync of its child values has occurred.
                if (control.updateFormattedValue) {
                    control.updateFormattedValue(newValue);
                    this.isChildDataDirty = false;
                }
            };
            /**
             * Call setValue on child controls and call resolve changes if the control is dirty
             * @returns A promise that gets resolved when the resolve changes process is completed
             */
            ReferenceGroup.prototype.resolveChanges = function () {
                var _this = this;
                var result;
                if (this.isChildDataDirty && this.allowUserChanges()) {
                    var children_5 = $dyn.value(this.Children);
                    if (children_5) {
                        var invalidChild_1 = false;
                        children_5.forEach(function (item) {
                            var itemAsEdit = item;
                            var itemAsInput = item;
                            if (!$dyn.value(itemAsEdit.IsValid)) {
                                // failed client-side validation
                                invalidChild_1 = true;
                            }
                            else if (!$dyn.value(_this.IsValid) || (itemAsInput.compareToParsedValue && !itemAsInput.compareToParsedValue($dyn.value(itemAsInput.Value)))) {
                                if (itemAsInput.setValue && itemAsInput.parsedValueToString) {
                                    itemAsInput.setValue(itemAsInput.parsedValueToString(), true);
                                }
                            }
                        });
                        if (invalidChild_1) {
                            this.isChildDataDirty = false;
                            // Don't call resolveChanges with client-side invalid child controls
                            return;
                        }
                    }
                    this.isChildDataDirty = false;
                    this.removeMessages();
                    result = $.Deferred();
                    var commandCallback = function (success) {
                        if (success) {
                            var children2 = $dyn.value(_this.Children);
                            if (children2) {
                                children2.forEach(function (item) {
                                    var itemAsInput = item;
                                    if (itemAsInput.updateParsedValue && itemAsInput.formattedValue && itemAsInput.compareToParsedValue && !itemAsInput.compareToParsedValue($dyn.value(itemAsInput.Value))) {
                                        item.updatingBlock(function () {
                                            itemAsInput.updateParsedValue($dyn.value(itemAsInput.Value));
                                            itemAsInput.formattedValue.valueChanged.raise();
                                        });
                                    }
                                });
                            }
                        }
                        result.resolve();
                    };
                    // Users should always select the value from the lookup (rather than typing) when recording scenarios for task guides.
                    var issueValueSelectionWarning = $dyn.value($dyn.ax.taskRecording.isRecording) && !$dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState);
                    if (issueValueSelectionWarning) {
                        $dyn.info({ Message: $dyn.label("Input_SelectValueFromLookup"), Label: "Input_SelectValueFromLookup" });
                    }
                    $dyn.callFunction(this.ResolveChanges, this, undefined, commandCallback);
                }
                if (!result) {
                    result = $.Deferred();
                    result.resolve();
                }
                return result;
            };
            ReferenceGroup.prototype.isMandatoryMet = function () {
                var e_3, _a;
                var met = false;
                if (this._childrenCollection && this._childrenCollection.length > 0) {
                    try {
                        for (var _b = __values(this._childrenCollection), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var child = _c.value;
                            if (child.isMandatoryMet && child.isMandatoryMet()) {
                                met = true;
                                break;
                            }
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
                return met;
            };
            /**
             * The keydown event handler
             * @param evt The keydown event
             */
            ReferenceGroup.prototype.keyDown = function (evt) {
                $dyn.util.handleShortcuts(this, evt);
                this.disableAutoPresentLookupForQuickEditGrids();
                this.autoPresentLookup(evt);
            };
            /**
             * Focus the first child control
             */
            ReferenceGroup.prototype.focusFirstChild = function () {
                if (this._childrenCollection && this._childrenCollection.length > 0) {
                    var $childInputElement = this._childrenCollection[0].$inputElement;
                    if ($childInputElement) {
                        $childInputElement.focus();
                    }
                }
            };
            /** @obsolete */
            ReferenceGroup.prototype.cellRenderer = function (rowIndex) {
                // Note: Could this cause issues if the child does not have a cell renderer?
                var childRenderer = this._childrenCollection[0].cellRenderer(rowIndex);
                return childRenderer;
            };
            ReferenceGroup.prototype.GetState = function () {
                var state = {
                    children: {}
                };
                var children = $dyn.value(this.Children);
                if (children) {
                    children.forEach(function (item) {
                        var itemAsInput = item;
                        if (itemAsInput.Name && itemAsInput.GetState) {
                            state.children[itemAsInput.Name] = itemAsInput.GetState();
                        }
                    });
                }
                return state;
            };
            ReferenceGroup.prototype.ApplyState = function (clientState) {
                if (clientState && clientState.children) {
                    var children_6 = $dyn.value(this.Children);
                    if (children_6) {
                        children_6.forEach(function (item) {
                            var itemAsInput = item;
                            if (itemAsInput.Name && itemAsInput.ApplyState) {
                                var childState = clientState.children[itemAsInput.Name];
                                itemAsInput.ApplyState(childState);
                            }
                        });
                    }
                }
                return this.resolveChanges();
            };
            ReferenceGroup.prototype.onSerializeTransitState = function () {
                var clientState = {};
                var children = $dyn.value(this.Children);
                if (children) {
                    children.forEach(function (item, i) {
                        var itemAsInput = item;
                        var formattedValue = itemAsInput.getFormattedValue ? itemAsInput.getFormattedValue() : "";
                        clientState["formattedValue" + i.toString()] = formattedValue;
                    });
                }
                // Send our formattedValues to the server so that it can be deserialized later.
                clientState = JSON.stringify(clientState);
                // Set ClientState
                $dyn.setValue(this, "ClientState", clientState);
            };
            ReferenceGroup.prototype.displayedValue = function () {
                var displayedValue;
                var children = $dyn.value(this.Children);
                if (children) {
                    var displayedValueArr_1 = [];
                    children.forEach(function (item) {
                        var itemAsInput = item;
                        if (itemAsInput.displayedValue) {
                            displayedValueArr_1.push(itemAsInput.displayedValue());
                        }
                    });
                    displayedValue = displayedValueArr_1.join(" ");
                }
                return displayedValue;
            };
            ReferenceGroup.prototype.displayedValues = function (onlyIncludeDirtyValues) {
                var displayedValues = {};
                var children = $dyn.value(this.Children);
                if (children) {
                    children.forEach(function (item) {
                        var itemAsInput = item;
                        if (itemAsInput.displayedValue && (!onlyIncludeDirtyValues || (itemAsInput.isDisplayedValueDirty && itemAsInput.isDisplayedValueDirty()))) {
                            displayedValues[item.Name] = itemAsInput.displayedValue();
                        }
                    });
                }
                return displayedValues;
            };
            ReferenceGroup.prototype.getDisplayedValueSource = function (event) {
                var displayedValueSource = this;
                if (event.target) {
                    // In Reference Group scenarios there isn't a concept of display value, since that's maintained by its children. Check the event to see which child is being interacted with
                    // and get displayedValue from that if possible.
                    var containedControlContext = $dyn.context(event.target);
                    if (containedControlContext) {
                        displayedValueSource = containedControlContext;
                    }
                }
                return displayedValueSource;
            };
            ReferenceGroup.prototype.applyClientState = function (clientState) {
                var children = $dyn.value(this.Children);
                if (children) {
                    children.forEach(function (item, i) {
                        var newFormattedValue = clientState["formattedValue" + i.toString()];
                        var itemAsInput = item;
                        if (itemAsInput.formattedValue && newFormattedValue !== undefined) {
                            itemAsInput.formattedValue(newFormattedValue);
                        }
                    });
                }
            };
            return ReferenceGroup;
        }(controls.Edit));
        controls.ReferenceGroup = ReferenceGroup;
        ReferenceGroup.prototype.RequestPopup = null;
        ReferenceGroup.prototype.ResolveChanges = null;
        ReferenceGroup.prototype.Width = $dyn.layout.Size.large;
        ReferenceGroup.prototype.CustomPopup = null;
        ReferenceGroup.prototype.isChildDataDirty = false;
        ReferenceGroup.prototype.LookupButton = true;
        ReferenceGroup.prototype.ShowFlyout = false;
        // tslint:disable:object-literal-sort-keys
        var referenceGroupShortcuts = {
            OpenLookup: {
                Keys: { alt: true, keyCode: $dyn.ui.KeyCodes.downArrow },
                Handler: function () {
                    if (this.allowUserChanges()) {
                        if ($dyn.log.popups) {
                            $dyn.log.popups("Popups: Alt+Down shortcut used to open/focus lookup for %s / %s; setting ShowFlyout to true; ShowFlyout currently equals %s", this.Name ? this.Name : "<unknown>", (this._element && this._element.id) ? this._element.id : "<unknown>", $dyn.peek(this.ShowFlyout));
                        }
                        this.TelemetryOptions = { inputType: $dyn.telemetry.InputType.keyboard };
                        this.openOrFocusLookup();
                        return true;
                    }
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: function () { return this.allowUserChanges(); },
                Description: $dyn.label("Input_OpenDropDown")
            },
            KeyForLookup: {
                Keys: {
                    keyCode: $dyn.util.Lookup.KeysToSendToLookup
                },
                Handler: controls.Edit.prototype.handleKeyDownForLookup,
                RecordTelemetry: false,
                ShowToUser: false,
            }
        };
        ReferenceGroup.prototype.Shortcuts = $dyn.extendPrototype(ReferenceGroup.prototype.Shortcuts, referenceGroupShortcuts);
        /**
         * Framework class for ReferenceGroupCell controls
         */
        var ReferenceGroupCell = /** @class */ (function (_super) {
            __extends(ReferenceGroupCell, _super);
            function ReferenceGroupCell() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return ReferenceGroupCell;
        }(ReferenceGroup));
        controls.ReferenceGroupCell = ReferenceGroupCell;
        $dyn.cellAdapter({ id: "ReferenceGroup" });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ReferenceGroup.js.map
